import * as React from 'react';
import { IconProps } from '../types';

const IcPreOrder = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M9.979 15.924A1.537 1.537 0 1 0 9.98 19a1.537 1.537 0 0 0-.002-3.075ZM15.09 15.924A1.538 1.538 0 1 0 15.092 19a1.538 1.538 0 0 0-.002-3.076ZM9.979 10.186a1.537 1.537 0 1 0 .004 3.074 1.537 1.537 0 0 0-.004-3.074ZM15.088 10.186a1.537 1.537 0 1 0 .004 3.075 1.537 1.537 0 0 0-.004-3.075ZM9.979 4.448a1.538 1.538 0 1 0 0 3.076 1.538 1.538 0 0 0 0-3.076ZM15.091 4.448a1.538 1.538 0 1 0 0 3.077 1.538 1.538 0 0 0 0-3.077Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h24v24H.5z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcPreOrder;
